
import React, {useState} from 'react';
// import './App.css'; - tu bol povodne
import {XMenu} from "./XMenu";
import {XUtilsMetadata} from "@michalrakus/x-react-web-lib/XUtilsMetadata";
import {XUtils} from "@michalrakus/x-react-web-lib/XUtils";
import {useAuth0} from "@auth0/auth0-react";

import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';

import './App.css'; // bol povodne ako prve css
import {XPostLoginRequest} from "./serverApi/XPostLoginIfc";
import {Utils, XUserNotFoundOrDisabledError} from "./Utils";

// window.screen.addEventListener("orientationchange", function () {
//     console.log("The orientation of the screen is: " + window.screen.orientation);
// });

/*
const ratio = window.devicePixelRatio || 1;
const w = window.screen.width * ratio;
const h = window.screen.height * ratio;
console.log('***************** fachci');
console.log(window.devicePixelRatio);
console.log(w);
console.log(h);
*/

//console.log(window.getComputedStyle(document.documentElement).fontSize);


// TODO - v buducnosti presunut do XReactWebLib
function AppAuth0() {


    const {user, isAuthenticated, isLoading, loginWithRedirect, logout, getAccessTokenSilently} = useAuth0();

    const [initialized, setInitialized] = useState(false);

    // useEffect(() => {
    //     fetchAndSetXEntityMap();
    // },[]); // eslint-disable-line react-hooks/exhaustive-deps

    const initializeApp = async () => {
        try {
            await setXTokenAndDoPostLogin();
            await fetchAndSetXMetadata();
            // vsetko zbehlo, app-ka je inicializovana
            setInitialized(true);
        }
        catch (err) {
            if (err instanceof XUserNotFoundOrDisabledError) {
                // prihlasil sa napr. gmail user, ktory nie je uvedeny v DB
                // zrusime nastaveny access token
                XUtils.setXToken(null);
                // odhlasime uzivatela
                logout({logoutParams: {returnTo: window.location.origin}});
            }
            else {
                // ak bola ina chyba, aplikacia spadne
                throw err;
            }
        }
    }

    const setXTokenAndDoPostLogin = async () => {

        // const accessToken: string = await getAccessTokenSilently(/*{
        //     audience: XUtils.getEnvVarValue(XEnvVar.REACT_APP_AUTH0_AUDIENCE)
        //     //scope: "openid profile admin:demo try:demo" - treba nam na nieco?
        // }*/);

        // neviem ci tu je idealne miesto kde nastavit metodku getAccessToken, zatial dame sem
        XUtils.setXToken({accessToken: getAccessToken});

        // zavolame post-login
        // - overime ci je user zapisany v DB (toto sa da obist - TODO - poriesit)
        // - zosynchronizujeme zmeny (pre pripad ak sa zmenilo napr. Meno, Priezvisko) - TODO
        let xPostLoginResponse;
        try {
            // UPOZORNENIE - username z json requestu sa pouziva iba pri XAuth.OFF, username tahame z usera z http requestu (security)
            const xPostLoginRequest: XPostLoginRequest = {username: user?.name};
            // standardny post-login nahradime specifickym post-login-depaul
            //xPostLoginResponse = await XUtils.fetch('post-login', xPostLoginRequest);
            xPostLoginResponse = await XUtils.fetch('post-login-depaul', xPostLoginRequest);
        }
        catch (e) {
            // console.log(typeof e);
            // console.log(e instanceof Error);
            const error: Error = e as Error;
            // console.log(JSON.stringify(error));
            console.log(error.stack);
            // console.log(error.message);
            // console.log(error.name);
            console.log(error.cause);

            XUtils.showErrorMessage('post-login failed', e);
            throw 'post-login failed';
        }

        if (xPostLoginResponse.xUser === undefined) {
            // nenasli sme usera v DB
            alert(`User account "${user?.email}" not found in DB. Login not permitted. Ask admin to create user account in DB.`);
            // pouzijeme custom exception ktoru neskor odchytime (krajsie riesenie ako vracat true/false)
            throw new XUserNotFoundOrDisabledError();
        }

        if (!xPostLoginResponse.xUser.enabled) {
            // user je disablovany
            alert(`User account "${user?.email}" is not enabled. Ask admin to enable user account.`);
            // pouzijeme custom exception ktoru neskor odchytime (krajsie riesenie ako vracat true/false)
            throw new XUserNotFoundOrDisabledError();
        }

        // ulozime si usera do access token-u - zatial take provizorne, user sa pouziva v preSave na setnutie vytvoril_id
        XUtils.setXToken({accessToken: XUtils.getXToken()?.accessToken, xUser: xPostLoginResponse.xUser});

        console.log("App - bol uspesne zavolany setXTokenAndDoPostLogin");
    }

    const fetchAndSetXMetadata = async () => {
        await XUtilsMetadata.fetchAndSetXEntityMap();
        console.log("App - bol zavolany XUtilsMetadata.fetchAndSetXEntityMap()");
        await XUtilsMetadata.fetchAndSetXBrowseMetaMap();
        console.log("App - bol zavolany XUtilsMetadata.fetchAndSetXBrowseMetaMap()");
        await Utils.fetchAndSetKodSluzbaRolaPravaMap();
    }

    // tato funkcia sa vola pred kazdym requestom na backend - vola sa v metode XUtils.fetchBasic
    // ked sa vola len pri inicializacii, tak token po case (24h default) exspiruje a user si musi restartnut aplikaciu
    const getAccessToken = async (): Promise<string> => {

        return await getAccessTokenSilently(/*{
            audience: Utils.getEnvVarValue(XEnvVar.VITE_AUTH0_AUDIENCE)
            //scope: "openid profile admin:demo try:demo" - treba nam na nieco?
        }*/);
    }

    let elem;
    if (isLoading) {
        elem = <div className="App-form">User is being initialized using Auth0...</div>;
    }
    else {
        if (!isAuthenticated) {
            // otvori Auth0 prihlasovaciu stranku
            loginWithRedirect();
            //elem = <div className="App-form"><button onClick={() => loginWithRedirect()}>Log In</button></div>;
        }
        else {
            if (!initialized) {
                elem = <div className="App-form">App is being initialized...</div>;
                initializeApp();
            }
            else {
                elem = <XMenu defaultFormElement={null} logout={() => logout({logoutParams: {returnTo: window.location.origin + window.location.pathname}})}/>;
            }
        }
    }

    return (
        <div className="App">
            {elem}
        </div>
    );
}

export default AppAuth0;
